import { getUserInfo, SecurityObject } from "~/domain/user-session"
import { fetchApi } from "~/shared/api"

/**
 * Проверяет доступ текущего пользователя с учетом указанного ограничения
 * @param objects объект(ы) с описанием ограничений
 * @returns
 */
export async function checkAccessTo(
	objects: SecurityObject | SecurityObject[],
) {
	const userInfo = getUserInfo()

	if (!userInfo) {
		return false
	}

	const result = await fetchApi("security/auth/check-access-to", {
		method: "POST",
		body: JSON.stringify({
			userId: userInfo.id,
			secure: objects,
		}),
	})

	return result.ok
}
